module.exports = __webpack_public_path__ + "static/media/how_sk.1a065459.vtt";